module.exports = __webpack_public_path__ + "static/img/target-oxbridge-2020.2896152.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/target-oxbridge-2020.png
// module id = H9gI
// module chunks = 0